import client from '../utils/axios'
import { API_VERSION, endSession, hasSession, storeTokens } from '../utils/session'

const REACT_APP_CLIENT_ID = process.env.REACT_APP_CLIENT_ID

// Initial State
const initialState = {
  // Check if Auth Token exists!
  authenticated: checkforAuthToken(),
  error: null, userExists: false, roles: [],
  user: {},
  profilePage: false,
  fetching: false,
  orgID: localStorage[`orgID`] ? JSON.parse(localStorage[`orgID`]) : undefined,
  userRole: localStorage['userRole'] ? JSON.parse(localStorage['userRole']) : undefined,
}

// Helpers
function checkforAuthToken() {
  return hasSession()
}

// Action constants
const LOGIN_USER = 'LOGIN_USER'
const LOGIN_USER_SUCCESS = `LOGIN_USER_SUCCESS`
const LOGIN_USER_FAILURE = `LOGIN_USER_FAILURE`
const LOGOUT_USER = 'LOGOUT_USER'
const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS'

const SHOW_PROFILE = `SHOW_PROFILE`
const CLOSE_PROFILE = `CLOSE_PROFILE`
const FORGOT_PASSWORD = `FORGOT_PASSWORD`
const FORGOT_PASSWORD_SUCCESS = `FORGOT_PASSWORD_SUCCESS`
const FORGOT_PASSWORD_FAILURE = `FORGOT_PASSWORD_FAILURE`

// GET User details
const GET_USER = 'GET_USER'
const GET_USER_SUCCESS = 'GET_USER_SUCCESS'
const GET_USER_FAILURE = 'GET_USER_FAILURE'

// POST Check Username Exists
const USER_EXISTS = 'USER_EXISTS'
const USER_EXISTS_SUCCESS = 'USER_EXISTS_SUCCESS'
const USER_EXISTS_FAILURE = 'USER_EXISTS_FAILURE'

// UPDATE user details
const UPDATE_USER_PASSWORD = 'UPDATE_USER_PASSWORD'
const UPDATE_USER_PASSWORD_SUCCESS = 'UPDATE_USER_PASSWORD_SUCCESS'
const UPDATE_USER_PASSWORD_FAILURE = 'UPDATE_USER_PASSWORD_FAILURE'

// Action creators
export const showProfile = () => ({ type: SHOW_PROFILE })
export const closeProfile = () => ({ type: CLOSE_PROFILE })

// The API clients attach the session token themselves (see utils/axios).
export const getHeaders = () => ({
  crossDomain: true,
  'client-id': REACT_APP_CLIENT_ID,
})

export const checkUserExists = (username) => {
  return ({
    types: [USER_EXISTS, USER_EXISTS_SUCCESS, USER_EXISTS_FAILURE],
    payload: {
      request: {
        url: `/users/username/exists`,
        method: 'POST',
        data: { username },
        skipAuth: true
      }
    }
  })
}

export const forgotPassword = (email) => {
  return ({
    types: [FORGOT_PASSWORD, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_FAILURE],
    payload: {
      request: {
        url: `/passwordreset`,
        method: 'POST',
        data: {
          username: email
        },
        skipAuth: true
      }
    }
  })
}

export const logout = () => async dispatch => {
  dispatch({ type: LOGOUT_USER })
  // Revoke server-side while the tokens are still in storage. Best effort: the local session
  // ends whatever legacy answers, so a failed revoke cannot keep the user signed in.
  await client.delete('/tokens').catch(() => undefined)
  endSession()
  dispatch({ type: LOGOUT_USER_SUCCESS })
}

export const login = (email, password) => {
  return ({
    types: [LOGIN_USER, LOGIN_USER_SUCCESS, LOGIN_USER_FAILURE],
    payload: {
      request: {
        url: `/tokens`,
        method: 'POST',
        headers: { 'api-version': API_VERSION },
        data: {
          username: email,
          user_password: password
        },
        skipAuth: true
      }
    }
  })
}

export const getUser = () => {
  const userID = JSON.parse(localStorage[`user_id`])

  return ({
    types: [GET_USER, GET_USER_SUCCESS, GET_USER_FAILURE],
    payload: {
      request: {
        url: `/users/${userID}`
      }
    }
  })
}

export const updateUserPassword = (old_password, user_password) => {
  const userID = JSON.parse(localStorage[`user_id`])

  return ({
    types: [UPDATE_USER_PASSWORD, UPDATE_USER_PASSWORD_SUCCESS, UPDATE_USER_PASSWORD_FAILURE],
    payload: {
      request: {
        url: `/users/${userID}`,
        method: 'PUT',
        data: {
          old_password,
          user_password
        }
      }
    }
  })
}

// Reducer
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_EXISTS:
      return { ...state, userExists: false, roles: [] }
    case USER_EXISTS_SUCCESS:
      return {
        ...state,
        userExists: action.payload.data && action.payload.data.data && action.payload.data.data.exist,
        roles: action.payload.data && action.payload.data.data && action.payload.data.data.roles ? action.payload.data.data.roles : []
      }
    case USER_EXISTS_FAILURE:
      return { ...state, userExists: false, roles: [] }
    case SHOW_PROFILE:
      return {
        ...state,
        profilePage: true
      }
    case CLOSE_PROFILE:
      return {
        ...state,
        profilePage: false
      }
    case FORGOT_PASSWORD:
      return {
        ...state,
        loginError: null
      }
    case FORGOT_PASSWORD_SUCCESS:
      if (!action.payload.data.error) {
        alert(action.payload.data.data[0].msg)
      }
      return {
        ...state,
        loginError: action.payload.data.error ? action.payload.data.error.text : null,
      }
    case FORGOT_PASSWORD_FAILURE:
      return {
        ...state
      }
    case LOGIN_USER:
      return {
        ...state
      }
    case LOGIN_USER_SUCCESS:
      if (!action.payload.data.error) {
        let { user: { user_id, organisationID: orgID, roles = [] } = {}, token, refresh_token } = action.payload.data.data[0]
        if (orgID)
          localStorage[`orgID`] = JSON.stringify(orgID)

        if (roles.length) localStorage['userRole'] = JSON.stringify(roles[0]);

        if (user_id && token) {
          storeTokens({ token, refresh_token })
          localStorage[`user_id`] = JSON.stringify(user_id)
        } else {
          return {
            ...state,
            loginError: `You are not authorised to use this platform`
          }
        }
      }
      return {
        ...state,
        loginError: action.payload.data.error ? action.payload.data.error.text : null,
        authenticated: action.payload.data.data ? true : false,
        profilePage: false,
        orgID: localStorage[`orgID`] ? JSON.parse(localStorage[`orgID`]) : undefined,
        userRole: localStorage['userRole'] ? JSON.parse(localStorage['userRole']) : undefined
      }
    case LOGIN_USER_FAILURE:
      return {
        ...state
      }
    case LOGOUT_USER:
      return {
        ...state
      }
    case LOGOUT_USER_SUCCESS:
      return { ...state, authenticated: false, orgID: null, userRole: null }
    case GET_USER:
      return {
        ...state,
        fetching: true
      }
    case GET_USER_SUCCESS:
      return {
        ...state,
        fetching: false,
        user: action.payload.data?.data?.length && action.payload.data.data[0]
      }
    case GET_USER_FAILURE:
      return {
        ...state,
        fetching: false,
      }
    case UPDATE_USER_PASSWORD:
      return {
        ...state
      }
    case UPDATE_USER_PASSWORD_SUCCESS:
      return {
        ...state
      }
    case UPDATE_USER_PASSWORD_FAILURE:
      return {
        ...state,
        error: action.error
      }
    default:
      return state
  }
}

export default authReducer;
